import { useSectionMetaData } from '@v4/components/common/SectionItem'
import useStyles from './Footer.styled'

export const useFooter = ({ variant, Element }) => {
	const metaData = useSectionMetaData()
	const classes = useStyles()

	return [
		{
			classes,
			metaData,
			Element,
			variant,
		},
	]
}
